import React from 'react'
import { TailSpin } from 'react-loader-spinner'

const Loader = () => {
  return (
        <TailSpin
  visible={true}
  height="full"
  width="full"
  color="#17bf9e"
  ariaLabel="tail-spin-loading"
  radius="1"
  wrapperStyle={{}}
  wrapperClass=""
  />      
  )
}

export default Loader